/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Event_Group_ToastInputs */



/**
* | output |
* | --- |
* | "No event group selected." |
*
* @param {Error_Nav_No_Event_Group_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_event_group_toast = /** @type {((inputs?: Error_Nav_No_Event_Group_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Event_Group_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe d'evenements selectionne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ereignisgruppe ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo di eventi selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий не выбрана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ningún grupo de eventos seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループが選択されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट समूह चयनित नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum grupo de eventos selecionado.")
	return /** @type {LocalizedString} */ ("No event group selected.")
});